/// <amd-module name="VSS/Redux/SharedStoreDynamicModuleLoader" />
import * as React from "react";
import { IModule, IModuleStore, DynamicModuleLoader } from "redux-dynamic-modules";
import { VssComponent } from "VSS/Platform/Layout";
import { IReduxStoreService } from "./StoreService";

export interface ISharedStoreDynamicModuleLoaderProps {
    modules: IModule<any>[];
    configureStore: () => IModuleStore<any>;
}

export class SharedStoreDynamicModuleLoader extends VssComponent<ISharedStoreDynamicModuleLoaderProps> {
    render() {
        return (
            <DynamicModuleLoader modules={this.props.modules} createStore={this._createStore}>
                {this.props.children}
            </DynamicModuleLoader>
        );
    }

    private _createStore = (): IModuleStore<any> => {
        const storeService = this.context.pageContext.getService<IReduxStoreService>("redux-store-service");
        return storeService.getStore(this.props.configureStore);
    };
}
